import { render } from "./Kaipiao.vue?vue&type=template&id=629dcf2a&scoped=true"
import script from "./Kaipiao.vue?vue&type=script&lang=js"
export * from "./Kaipiao.vue?vue&type=script&lang=js"

import "./Kaipiao.vue?vue&type=style&index=0&id=629dcf2a&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629dcf2a"]])

export default __exports__